<script>
  import { format } from 'svelte-i18n';

  import { PUSH_ACTION_COLORS, PUSH_ACTION_MODE } from '@client/enums';
</script>

<ul class="d-flex mt-2 text-muted">
  {#each Object.keys(PUSH_ACTION_MODE) as mode}
    <li class="me-3">
      <span style="color: #{PUSH_ACTION_COLORS[mode]}">●</span>
      <small>{$format(PUSH_ACTION_MODE[mode])}</small>
    </li>
  {/each}
</ul>
